import { Modal } from "antd";
import { useGlobalContext } from "../../context/GlobalContext";

export const LgLogoModal = () => {
  const { data, updateData } = useGlobalContext();
  const { openLogo, selectedLogo } = data || {};

  const handleClose = () => {
    updateData("openLogo", false);
    updateData("selectedLogo", null);
  };

  return (
    <Modal
      open={!!openLogo}
      onCancel={handleClose}
      footer={null}
      title="District Logo"
    >
      {selectedLogo ? (
        <div style={{ textAlign: "center" }}>
          <img
            src={selectedLogo}
            alt="District Logo"
            style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8 }}
          />
        </div>
      ) : (
        <p>No logo available</p>
      )}
    </Modal>
  );
};
